/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CommunicationPermissions } from './communicationPermissions';
import { CorePermissions } from './corePermissions';
import { SettingsPermissions } from './settingsPermissions';
import { BookingPermissions } from './bookingPermissions';
import { TasksPermissions } from './tasksPermissions';
import { PatientsPermissions } from './patientsPermissions';
import { UsersPermissions } from './usersPermissions';


import {ValidatorFn, Validators} from "@angular/forms";

export interface UserPermissions { 
    booking: BookingPermissions;
    communication: CommunicationPermissions;
    core: CorePermissions;
    patients: PatientsPermissions;
    settings: SettingsPermissions;
    tasks: TasksPermissions;
    users: UsersPermissions;
}
export const UserPermissions_booking_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserPermissions_communication_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserPermissions_core_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserPermissions_patients_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserPermissions_settings_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserPermissions_tasks_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserPermissions_users_Validators: ValidatorFn[] =
    [  Validators.required, ];


